import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Typography from "material-ui-next/Typography";
import Paper from "material-ui-next/Paper";

import {
  Loadable,
  Page,
  If,
  TextField,
  StyledButton
} from "components/support";
import Device from "./device";

class DeviceView extends Component {
  showDevices = (device, index) => {
    const { presenter, viewModel } = this.props;

    return (
      <Col xs={12} sm={6} md={4} key={device.uuid}>
        <Device
          device={device}
          currentUser={viewModel.currentUser}
          onToggle={(_, toggle) => presenter.onToggle(device, toggle)}
          onChange={(field, value) => presenter.onChange(field, index, value)}
          onChangeConfig={(field, value) =>
            presenter.onChangeConfig(field, index, value)
          }
          onSaveConfig={() => presenter.onSaveConfig(index)}
          onAccept={() => presenter.onAccept(index)}
          onClose={() => presenter.onClose(index)}
        />
      </Col>
    );
  };

  render() {
    const { presenter, viewModel } = this.props;
    const { loading, devices, pagination } = viewModel;
    const { page, totalPage } = pagination;

    return (
      <Page>
        <Row>
          <Col xs={12} sm>
            <Typography type="display1" className="pb-sm">
              Dispositivos
            </Typography>
          </Col>
        </Row>
        <Row>
          <Col xs={12}>
            <Loadable loading={loading}>
              <If test={devices.length > 0}>
                <Row>{devices.map(this.showDevices)}</Row>
              </If>
              <If test={devices.length === 0}>
                <Paper elevation={1} className="full-width">
                  <Typography type="headline" className="p-md text-center">
                    Essa empresa não possui nenhum dispositivo configurado
                  </Typography>
                </Paper>
              </If>
            </Loadable>
          </Col>
        </Row>

        <Paper elevation={1} className="full-width mb-md">
          <Row center="xs" middle="xs">
            <Col xs>
              <StyledButton
                label="ANTERIOR"
                disabled={page <= 1}
                flat
                style={{ margin: "0px 8px" }}
                onTouchTap={() => page > 1 && presenter.onPageChange(page - 1)}
              />
            </Col>
            <Col xs>
              <span>Página</span>
              <TextField
                fieldWidth={70}
                type="number"
                value={page}
                onChange={(_, page) =>
                  presenter.onPageChange(parseInt(page, 10))
                }
                style={{ margin: "4px 8px 8px" }}
                inputStyle={{ textAlign: "center" }}
              />
              <span>de {totalPage}</span>
            </Col>
            <Col xs>
              <StyledButton
                label="PRÓXIMO"
                disabled={page >= totalPage}
                flat
                style={{ margin: "0px 8px" }}
                onTouchTap={() =>
                  page < totalPage && presenter.onPageChange(page + 1)
                }
              />
            </Col>
          </Row>
        </Paper>
      </Page>
    );
  }
}

export default DeviceView;



// WEBPACK FOOTER //
// ./src/components/app/registration/device/list/view.jsx